import service from '@/utils/request';

// @Tags partner
// @Summary 获取伙伴列表
// @Security ApiKeyAuth
// @Produce  application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"返回成功"}"
// @Router /partner/partnerList [post]
export var partnerList = function partnerList(data) {
  return service({
    url: "/xcpGameData/partner/partnerList",
    method: 'post',
    data: data
  });
};

//伙伴列表下拉框
export var partnerListAll = function partnerListAll(data) {
  return service({
    url: "/xcpGameData/partner/partnerListAll",
    method: 'post',
    data: data
  });
};